"use client";

import { c as _c } from "react/compiler-runtime";
import type { GetSectionType } from "page";
import SmallCard from "app/(site)/(blog-templates)/(blog-template-1)/(blog)/[blogSlug]/components/SmallCard";
import PrimaryCta from "app/components/PrimaryCta";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import { Wrapper, Inner, Grid, CtaWrapper } from "data:text/javascript;base64,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";
const PAGE_SIZE = 9;
export default function CustomerPagePosts(t0) {
  const $ = _c(26);
  const {
    posts,
    headerMode
  } = t0;
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const t1 = useSearchParams();
  let t2;
  if ($[0] !== t1) {
    t2 = t1.has("debug");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isDebug = t2;
  let T0;
  let T1;
  let T2;
  let hasMore;
  let t3;
  let t4;
  let t5;
  if ($[2] !== headerMode || $[3] !== isDebug || $[4] !== posts || $[5] !== visibleCount) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const basePosts = posts ?? [];
      const allPosts = isDebug ? [1, 2, 3, 4, 5].flatMap(i => basePosts.map(p => ({
        ...p,
        _id: `${p._id}-debug-${i}`
      }))) : basePosts;
      const visiblePosts = allPosts.slice(0, visibleCount);
      hasMore = visibleCount < allPosts.length;
      if (allPosts.length === 0) {
        t5 = null;
        break bb0;
      }
      T2 = Wrapper;
      t4 = headerMode;
      T1 = Inner;
      T0 = Grid;
      t3 = visiblePosts.map(_temp);
    }
    $[2] = headerMode;
    $[3] = isDebug;
    $[4] = posts;
    $[5] = visibleCount;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = hasMore;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    hasMore = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[13] !== T0 || $[14] !== t3) {
    t6 = <T0>{t3}</T0>;
    $[13] = T0;
    $[14] = t3;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== hasMore) {
    t7 = hasMore && <CtaWrapper><PrimaryCta type="button" tone="dark" onClick={() => setVisibleCount(_temp2)}>More Customer Stories</PrimaryCta></CtaWrapper>;
    $[16] = hasMore;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== T1 || $[19] !== t6 || $[20] !== t7) {
    t8 = <T1>{t6}{t7}</T1>;
    $[18] = T1;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== T2 || $[23] !== t4 || $[24] !== t8) {
    t9 = <T2 data-header-mode={t4}>{t8}</T2>;
    $[22] = T2;
    $[23] = t4;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp2(n) {
  return n + PAGE_SIZE;
}
function _temp(post) {
  return <SmallCard key={post._id} data={post} variant="light" isCustomerPage={true} />;
}